import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';

const headCells = [


 
  
  { id: 'sb_title', numeric: false, label: 'Title' },
  { id: 'sb_amount', numeric: false, label: 'Amount' },
  { id: 'sb_gstpercentage', numeric: false, label: 'GST %.' },
    { id: 'type', numeric: false, label: 'Class Type' },
	 { id: 'sb_noofdays', numeric: false, label: 'No. of Days' },
	 { id: 'sb_extramt', numeric: false, label: 'Extra Amount' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Subscription extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,sb_noofdays:'',sb_extramt:'',
      Subcriptiondata:[],sbid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchsubscription:'',type:'',title:'',todate:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage); }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Subcriptiondata:[]
    });
	
 
}
	


	componentWillMount() { 

	
	document.title = "AthayogaLiving - Subscription Management";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
}


	




handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxsubscription.php?action=getall&sb_title='+this.state.names+'&sb_type='+this.state.type+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Subcriptiondata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Subcriptiondata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      subscribeDelete(sbid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('sb_id',sbid)
	 	   
	formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxsubscription.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); });
   
 
  
  
    
            });
 }
      }
	  ActiveInActiveStatusUpdate(sb_id, displaystatus) {
  let message;

  if (displaystatus === 0) {
    message = window.confirm("Do you really want to Hide from app?");
  } else if (displaystatus === 1) {
    message = window.confirm("Do you really want to Display in app?");
  }

  if (message === true) {
    const formData = new FormData();
    formData.append('action', 'ActiveStatus');
    formData.append('sb_id', sb_id);
 
	    formData.append('sb_isdisplayinapp', displaystatus);
    formData.append('userid', localStorage.getItem("ISIuserid"));

    axios.post(Serverurl+ "ajaxsubscription.php", formData)
      .then(res => {
        this.apicall(this.state.page, this.state.rowsPerPage);
      })
  }
}
      Subscribeaddbox(val){
        this.setState({ sbid: val },()=>{this.refs.AddSubscribebox.handleClickOpen()});  
  
 

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   

<div className="boxheading">
				 
<h2>Manage Subscription</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">

  <ul>
 
 <li><p>Title</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			placeholder="Name" 
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
		
	<li><p>Class Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native 
		 variant="outlined"
          margin="normal"  inputProps={{tabIndex: "2"}}
		  className="txtbox"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.type}
		  name="type"
		
        >
	
	<option value="">Select Class Type</option>
          <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in Studio</option>

 <option value={3}>Group </option>
 <option value={4}>Prenatal</option> <option value={5}>Product</option> 
  <option value={6}>Personal Training Online</option>
  <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>
	</li>		
	
	
		
		<li>
		<p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Subscribeaddbox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		
		
		
		
		</ul>
		
</div>		



<AddSubscribebox ref="AddSubscribebox" id={this.state.sbid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Subcriptiondata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Subcriptiondata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.sb_title}</TableCell>
<TableCell>{item.sb_amount}</TableCell>
<TableCell>{item.sb_gstpercentage}</TableCell>
<TableCell>{item.type}</TableCell>
<TableCell>{item.sb_noofdays}</TableCell>
<TableCell>
  {item.sb_extramt ? item.sb_extramt : 0}
</TableCell>

<TableCell align="left">
{item.sb_title!=="Trail Class" && ( <React.Fragment>

<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Subscribeaddbox(item.sb_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;

{item.delcnt==="0" && (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.subscribeDelete(item.sb_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>)}

{item.sb_isdisplayinapp === "0" && (
  <Button variant="contained" className="frmSecondarybtn" onClick={() => {this.ActiveInActiveStatusUpdate(item.sb_id,1)}} >
    Display in app
  </Button>
)}
{item.sb_isdisplayinapp === "1" && (
  <Button variant="contained" className="frmthirdbtn" onClick={() => {this.ActiveInActiveStatusUpdate(item.sb_id,0)}} >
    Hide from app
  </Button>
)}
 </React.Fragment>
)}



 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
         rowsPerPageOptions={[10,50,100,150]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}


export  class  AddSubscribebox extends Component {

   constructor(props) {
      super(props)
	 
      this.state = {
		  sb_noofdays:'',sb_extramt:'',
		   open:false,name:'',sb_id:0,names:'',amount:'',gstpercentage:'',type:0,
      errormessage:'',erropen:false,alerttype:"error",subdisable:false,btnSave:'Save',
	  }
      
  }
  
  
  
 Subscriptiongetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxsubscription.php?action=getall&sb_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
		if(resp.data[0].sb_ispartialpayement === "1" )
		{
			this.setState({checkedispartialpayment:true,ispartialpayment:"1"})
			
		}
		else{
			this.setState({checkedispartialpayment:false,ispartialpayment:"0"})
		}
    this.setState({ 
     
      sb_id:resp.data[0].sb_id,
	  name: resp.data[0].sb_title,
      amount: resp.data[0].sb_amount,
	  type: resp.data[0].sb_type,
gstpercentage: resp.data[0].sb_gstpercentage,	  
sb_noofdays: resp.data[0].sb_noofdays,	 
sb_extramt: resp.data[0].sb_extramt,	 
   
    
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  name:'',
	 type:'',
	 amount:'',
	 gstpercentage:'',
	 sb_id:0,
	 sb_noofdays:'',
	 sb_extramt:'',
	
	 
	  }); 
 }
  
    }

   
handleClickOpen = (event) => {

  this.setState({open:!this.state.open,  name:'',percentage:'',amount:'',gstpercentagen:'', 
     errormessage:'',erropen:false,sb_noofdays:'',sb_extramt:'',
	  });
		this.Subscriptiongetdata();
		


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9.\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="amount" || nam==="gstpercentage" || nam==="sb_noofdays")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
 
  
  }
  else{
  this.setState({[nam]: val});
  }
  

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


Savesubscribe = (event) => {

	let ispartialpayment;
 let name = this.state.name;
 let amount = this.state.amount;
 let type = this.state.type;
 let gstpercentage = this.state.gstpercentage;
 let sb_noofdays = this.state.sb_noofdays;
 let sb_extramt = this.state.sb_extramt;




let percentage;


if(name==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}



if(amount==="")
{
	
	this.setState({errormessage:"Please Enter Amount",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(type==="")
{
	
	this.setState({errormessage:"Please Select Class Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(gstpercentage==="")
{
	
	this.setState({errormessage:"Please Enter Percentage",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(sb_noofdays==="")
{
	
	this.setState({errormessage:"Please Enter Number Of Days",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
this.setState({errormessage:"",erropen:false,subdisable:true,btnSave:'Processing...',});
	
   var formData = new FormData();
  
  
   if(this.state.sb_id===0)
	  {
		  formData.append('sb_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('sb_id',this.state.sb_id)
		
     }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('sb_title',name)
		formData.append('sb_amount',amount)
		formData.append('sb_type',type)
		formData.append('sb_gstpercentage',gstpercentage)
		formData.append('sb_noofdays',sb_noofdays)
		formData.append('sb_extramt',sb_extramt)
	
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxsubscription.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({alerttype:"info",errormessage:"Title Already Exist.",erropen:true,open:true,subdisable:true,btnSave:'Processing...',
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
	
	this.setState({open:false,subdisable:true,btnSave:'Processing...',});
            this.props.updateDonenew();
	}
    
        });
  
	
	
};

handlelvbxChange = (event) => {
   
	this.setState({checkedispartialpayment: !this.state.checkedispartialpayment});
	setTimeout(() =>this.dispartialpay(this.state.checkedispartialpayment),200);

  };	
 dispartialpay(leaval){	 
	 if(leaval===true)
	 {
		 this.setState({ ispartialpayment:"1"})
	 }
	 
	 else{
		 this.setState({ ispartialpayment:"0"})
	 }
	 
 }
	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClickOpen} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Manage Subscription</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
<p> <span className="validation">*</span> Amount</p>
	
	<p><TextField name="amount" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.amount}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "2",maxLength:7}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>		
	<p> <span className="validation">*</span>Class Type</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal" inputProps={{tabIndex: "3"}} className="txtbox"
          onChange={this.myChangeHandler}
          id="slottype"
		   value={this.state.type}
		  name="type"
		
        >
	
		<option value="">Select Preference</option>
          <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in Studio</option>

 <option value={3}>Group </option>
 <option value={4}>Prenatal</option>  <option value={5}>Product</option> 
  <option value={6}>Personal Training Online</option>
    <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>					  
	<p> <span className="validation">*</span> GST %</p>
	
	<p><TextField name="gstpercentage" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.gstpercentage}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:3}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>

						  
					<p> <span className="validation">*</span> Number Of Days</p>
	
	<p><TextField name="sb_noofdays" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.sb_noofdays}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:3}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	  
	<p> <span className="validation"></span>Additional payment</p>
	
	<p><TextField name="sb_extramt" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.sb_extramt}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:10}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	  
	
		
       <div className="actionbtns">
	   <div className="cancelbtn">	
<Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
     </div> 
<div className="savebtn">
<Button variant="contained" disable={this.state.subdisable} className="frmSecondarybtn" onClick={this.Savesubscribe}>
   {this.state.btnSave}
</Button>  

</div>    	
<div className="clear"></div>
 </div>     
	</div>		 
</DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  